import {
  GET_DISPUTES_SUCCESS,
  GET_DISPUTES_FAIL,
  GET_DISPUTE_SUCCESS,
  GET_DISPUTE_FAIL,
  CREATE_DISPUTE_SUCCESS,
  CREATE_DISPUTE_FAIL,
  UPDATE_DISPUTE_SUCCESS,
  UPDATE_DISPUTE_FAIL,
  DELETE_DISPUTE_SUCCESS,
  DELETE_DISPUTE_FAIL,
  CHANGE_DISPUTE_STATUS_SUCCESS,
  CHANGE_DISPUTE_STATUS_FAIL,
  ADD_DISPUTE_LOG_SUCCESS,
  ADD_DISPUTE_LOG_FAIL,
  RESPOND_TO_DISPUTE_SUCCESS,
  RESPOND_TO_DISPUTE_FAIL,
  REJECT_DISPUTE_SUCCESS,
  REJECT_DISPUTE_FAIL,
  RESET_DISPUTE,
} from "./actionTypes"

const INIT_STATE = {
  disputes: [],
  selectedDispute: null,
  loading: false,
  error: null,
  pagination: {
    pageIndex: 0,
    pageSize: 10,
    totalCount: 0,
    totalPages: 0,
    hasPreviousPage: false,
    hasNextPage: false,
  },
}

const Disputes = (state = INIT_STATE, action) => {
  switch (action.type) {
    // Get All Disputes
    case GET_DISPUTES_SUCCESS:
      return {
        ...state,
        disputes: action.payload.items || [],
        pagination: {
          pageIndex: action.payload.pageIndex || 0,
          pageSize: action.payload.pageSize || 10,
          totalCount: action.payload.totalCount || 0,
          totalPages: action.payload.totalPages || 0,
          hasPreviousPage: action.payload.hasPreviousPage || false,
          hasNextPage: action.payload.hasNextPage || false,
        },
        loading: false,
        error: null,
      }

    case GET_DISPUTES_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    // Get Dispute By ID
    case GET_DISPUTE_SUCCESS:
      return {
        ...state,
        selectedDispute: action.payload,
        loading: false,
        error: null,
      }

    case GET_DISPUTE_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    // Create Dispute
    case CREATE_DISPUTE_SUCCESS:
      return {
        ...state,
        disputes: [action.payload, ...state.disputes],
        loading: false,
        error: null,
      }

    case CREATE_DISPUTE_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    // Update Dispute
    case UPDATE_DISPUTE_SUCCESS:
      return {
        ...state,
        disputes: state.disputes.map(d =>
          d.id === action.payload.id ? action.payload : d
        ),
        selectedDispute: state.selectedDispute?.id === action.payload.id
          ? action.payload
          : state.selectedDispute,
        loading: false,
        error: null,
      }

    case UPDATE_DISPUTE_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    // Delete Dispute
    case DELETE_DISPUTE_SUCCESS:
      return {
        ...state,
        disputes: state.disputes.filter(d => d.id !== action.payload),
        selectedDispute: state.selectedDispute?.id === action.payload
          ? null
          : state.selectedDispute,
        loading: false,
        error: null,
      }

    case DELETE_DISPUTE_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    // Change Dispute Status
    case CHANGE_DISPUTE_STATUS_SUCCESS:
      return {
        ...state,
        disputes: state.disputes.map(d =>
          d.id === action.payload.id ? { ...d, ...action.payload } : d
        ),
        selectedDispute: state.selectedDispute?.id === action.payload.id
          ? { ...state.selectedDispute, ...action.payload }
          : state.selectedDispute,
        loading: false,
        error: null,
      }

    case CHANGE_DISPUTE_STATUS_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    // Add Dispute Log
    case ADD_DISPUTE_LOG_SUCCESS:
      return {
        ...state,
        selectedDispute: {
          ...state.selectedDispute,
          logs: [...(state.selectedDispute?.logs || []), action.payload],
        },
        loading: false,
        error: null,
      }

    case ADD_DISPUTE_LOG_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    // Respond to Dispute
    case RESPOND_TO_DISPUTE_SUCCESS:
      return {
        ...state,
        disputes: state.disputes.map(d =>
          d.id === action.payload.id ? { ...d, ...action.payload } : d
        ),
        selectedDispute: state.selectedDispute?.id === action.payload.id
          ? { ...state.selectedDispute, ...action.payload }
          : state.selectedDispute,
        loading: false,
        error: null,
      }

    case RESPOND_TO_DISPUTE_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    // Reject Dispute
    case REJECT_DISPUTE_SUCCESS:
      return {
        ...state,
        disputes: state.disputes.map(d =>
          d.id === action.payload.id ? { ...d, ...action.payload } : d
        ),
        selectedDispute: state.selectedDispute?.id === action.payload.id
          ? { ...state.selectedDispute, ...action.payload }
          : state.selectedDispute,
        loading: false,
        error: null,
      }

    case REJECT_DISPUTE_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    // Reset
    case RESET_DISPUTE:
      return {
        ...state,
        selectedDispute: null,
        error: null,
      }

    default:
      return state
  }
}

export default Disputes
